import React from 'react';

const Settings = () => {
    return (
        <div>
            I am Settings
        </div>
    );
};

export default Settings;